/**
 * 클라이언트 공통 유틸리티 함수
 * 여러 모듈에서 공유되는 헬퍼 함수들
 */

const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** HTML 이스케이프 */
export function escapeHtml(str: string): string {
  return str.replace(/[&<>"']/g, (ch) => HTML_ESCAPES[ch] || ch);
}

/** 아바타 그라디언트 클래스 반환 */
const AVATAR_GRADIENTS = ['avatar-g1','avatar-g2','avatar-g3','avatar-g4','avatar-g5','avatar-g6','avatar-g7','avatar-g8'];
export function getAvatarGradient(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_GRADIENTS[Math.abs(hash >>> 0) % AVATAR_GRADIENTS.length];
}

function getSetting<T>(key: string, def: T): T {
  try { const v = localStorage.getItem('kalpha_setting_' + key); return v ? JSON.parse(v) : def; } catch { return def; }
}

/** 상대 시간 포맷 (예: "3분 전", "2시간 전") */
export function formatTime(timestamp: number): string {
  const fmt = getSetting('timeFormat', 'relative');
  const date = new Date(timestamp * 1000);
  if (fmt === '24h') return `${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
  if (fmt === '12h') { const h = date.getHours(); const ampm = h >= 12 ? '오후' : '오전'; const h12 = h % 12 || 12; return `${ampm} ${h12}:${String(date.getMinutes()).padStart(2,'0')}`; }

  const diff = Math.floor(Date.now() / 1000) - timestamp;
  if (diff < 60) return '방금 전';
  if (diff < 3600) return `${Math.floor(diff / 60)}분 전`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}시간 전`;

  const now = new Date();
  if (date.getFullYear() === now.getFullYear()) return `${date.getMonth() + 1}월 ${date.getDate()}일`;
  return `${date.getFullYear()}. ${date.getMonth() + 1}. ${date.getDate()}.`;
}

/** 짧은 시간 포맷 (HH:MM 또는 12h) */
export function formatTimeShort(timestamp: number): string {
  const fmt = getSetting('timeFormat', 'relative');
  const date = new Date(timestamp * 1000);
  const m = String(date.getMinutes()).padStart(2, '0');
  if (fmt === '12h') {
    const h = date.getHours();
    const h12 = h % 12 || 12;
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${String(h12).padStart(2, '0')}:${m} ${ampm}`;
  }
  return `${String(date.getHours()).padStart(2, '0')}:${m}`;
}
